<script setup>
import {ref, onBeforeMount} from "vue";
import {userInfoStore} from "@/store/store.js";
import rules from "@/utils/validator-rules.js";
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js"
import {userLogoutHooks} from "@/hooks/user.js";
const {route} = getRoute()

/*初次加载*/
onBeforeMount(() => {
  // TODO 重新做判断逻辑还是删除逻辑？
  // if (!info.club) {
  //   console.log("没有俱乐部信息，进行页面跳转")
  //   showCreatClub.value = true
  // }
})

// 父组件传值
const props = defineProps({
  // 面包屑导航信息
  bread: {
    type: Array,
    default: () => []
  }
})
const info = userInfoStore().info;
const user = {
  fullName: info.nickname ? info.nickname : info.username,
  email: info.email ? info.email : '-',
  avatar: info.avatar ? info.avatar : '',
}
// 裁剪账号昵称
const cutName = (name) => {
  return rules.isChinese(name.slice(0, 2)) ? name.slice(0, 1) : name.slice(0, 2)
}
// 未读通知数量
const unreadNotice = ref(0)
// 处理未读通知
const handleUnread = (number) => {
  if (number > 99) {
    return "99+"
  } else {
    return number
  }
}

// 处理点击通知
const handleClickNotice = () => {
  ElMessage.warning("敬请期待")
}

// 创建俱乐部弹窗状态
const showCreatClub = ref(false)

// 登出
const handleLogout = () => {
  userLogoutHooks()
}

// 跳转到创建页面
const handle2CreatClub = () => {
  router.push("/store/createClub")
}
</script>

<template>
  <div class="header_box flex_bt">
    <div class="flex_left">
      <v-btn v-if="props.bread.length > 0" style="margin-left: 15px;" variant="text" icon="" @click="router.back()">
        <template v-slot:default>
          <img style="width: 22px;height: 20px" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/header/header/header_back.svg"/>
        </template>
      </v-btn>
      <div class="header_bread">
        <v-breadcrumbs :items="props.bread"></v-breadcrumbs>
      </div>
    </div>
    <div class="flex_right">
      <div class="header_notice_box" style="margin-right: 58px" @click="handleClickNotice">
        <img style="width: 35px;height: 35px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/header/header/header_notice.svg">
        <div v-if="unreadNotice > 0" class="header_notice_tips">{{ handleUnread(unreadNotice) }}</div>
      </div>
      <div class="header_avatar">
        {{ cutName(user.fullName) }}
      </div>
      <div class="header_avatar_txt" style="margin-left: 15px">
        <span style="color: #1d253b" v-html="user.fullName"></span>
      </div>
    </div>
  </div>
  <el-dialog
      v-model="showCreatClub"
      align-center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="540px"
      @close="handleLogout"
  >
    <template #header>
      <div class="logout_header fwb txt_left">是否补充信息？</div>
    </template>
    <span>你当前使用账号还没有创建俱乐部，需要补充录入相关信息才可进入管理页面。</span>
    <template #footer>
      <div class="dialog-footer mt60">
        <v-btn class="br10" color="#d7d7df" @click="showCreatClub = false">取消</v-btn>
        <v-btn class="br10 ml20" color="#4CAF50" @click="handle2CreatClub">填写资料</v-btn>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.header_box {
  width: 100%;
  min-width: 950px;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0 1px 6px 0 rgba(25, 24, 27, 0.1);
  border-radius: 15px;
  margin: 14px 20px 0 0;
  padding: 18px 25px 18px 25px;
  .header_bread {
    font-weight: 500;
    font-size: 21px;
    color: #000000;
  }
  .header_avatar {
    width: 40px;
    height: 40px;
    background: #EBEBEB;
    border-radius: 50%;
    font-weight: 500;
    font-size: 20px;
    color: #ADABB0;
    line-height: 40px;
  }
  .header_avatar_txt {
    font-weight: 500;
    font-size: 14px;
    color: #272539;
  }
  .header_notice_box {
    width: 35px;
    height: 35px;
    position: relative;
    cursor: pointer;
    .header_notice_tips {
      min-width: 25px;
      min-height: 25px;
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
      background: #CC3A3A;
      border-radius: 50%;
      box-sizing: border-box;
      line-height: 25px;
    }
  }
}
</style>
